import { render } from "./ContactUs.vue?vue&type=template&id=0e2684d2&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=0e2684d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e2684d2"

export default script